import React from "react";
import ToolBar from "../../../components/toolbar/ToolBar";
import url from '../../../url'
import Select from "react-select";
import axios from "axios";
import { getFDate } from "../../../util/date";
import { store } from 'react-notifications-component';
import Loading from "../../../components/loading/Loading";
import ModernAlert from "../../../components/alert/ModernAlert";
import './checklist.css'
import LGCard from "../../../components/lg-card/LGCard";
import ListEvents from "../../../components/list-events/ListEvents";



class Checklist extends React.Component {
    listData = [
        { label: 'Name sjfhjdfhs snjksnfw sbndjnsjd jakbsdjksbn', value: 'valor', color: { rgb: 'rgb(252,3,3)', dark: true } },
        { label: 'Name', value: 'valor', color: { rgb: 'rgb(252,3,3)', dark: true } },
        { label: 'Name', value: 'valor', color: { rgb: 'rgb(252,3,3)', dark: true } },
        { label: 'Name', value: 'valor', color: { rgb: 'rgb(252,3,3)', dark: true } },
        { label: 'Name', value: 'valor', color: { rgb: 'rgb(252,3,3)', dark: true } },
        { label: 'Name', value: 'valor', color: { rgb: 'rgb(252,3,3)', dark: true } },
        { label: 'Name', value: 'valor', color: { rgb: 'rgb(252,3,3)', dark: true } },
        { label: 'Name', value: 'valor', color: { rgb: 'rgb(252,3,3)', dark: true } },
        { label: 'Name', value: 'valor', color: { rgb: 'rgb(252,3,3)', dark: true } },
        { label: 'Name', value: 'valor', color: { rgb: 'rgb(252,3,3)', dark: true } },
    ]
    constructor(props) {
        super(props)

        this.state = {
            drivers: { options: [], loading: false },
            licenseNumbers: { options: [], loadingD: false },
            optionsFailure: [],
            table: {},
            alert: { msg: '', type: '' },
            loading: true,
            filter: {
                startPeriod: "",
                endPeriod: "",
                optionsFailure: [],
                idDrivers: [],
                idVehicles: [],
            }

        }
    }




    componentDidMount() {
        this.getDash()
        this.getFailures();
    }

    getFailures = () => {
        axios
            .get(`${url}/v1/telemetria/admin/cache/checklist/failures/${this.props.token}`)
            .then(d => {
                this.setState({ optionsFailure: d.data });
            })
            .catch(e => console.log(e.response));
    };

    getDash = data => {
        this.setState({ loading: true, table: [], alert: { msg: '', type: '' } });
        axios({
            method: !data ? 'get' : 'post',
            url: `${url}/v1/telemetria/admin/report/checklist/dashboard/${this.props.token}`,
            data
        }).then(d => {
            var msg = d.data.listGeneralAttr[0].value === '0' ? 'Não encontramos dados para os filtros selecionados.' : ''
            // console.log(d.data)
            this.setState({ loading: false, filter: {...d.data.filter, groupName: []}, alert: { type: '', msg }, data: d.data })
            console.log(d.data)
        }).catch(e => {
            console.log(e.response)
            var errorMsg = e.response.data.errorMessage
            this.setState({ loading: false })
            errorMsg.forEach(d => {
                if (d === "Sessão expirada!") this.props.validateToken(this.props.token)
                else store.addNotification({ ...this.props.bodyNotify, title: d, type: 'danger' });
            })
        })
    };


    renderToolbar = () => {
        return (
            <ToolBar>
                <div>
                    <label htmlFor="start-date" className='toolbar-label'>Inicio</label>
                    <input
                        id='start-date'
                        type="date"
                        className='form-control toolbar-date'
                        onChange={(i) => this.setState({ filter: { ...this.state.filter, startPeriod: i.target.value } })}
                        disabled={this.state.loading}
                        placeholder='Inicio'
                        max={getFDate()}
                        value={this.state.filter.startPeriod} />
                </div>

                <div>

                    <label htmlFor="end-period" className='toolbar-label'>Fim</label>
                    <input
                        id='end-period'
                        type="date"
                        className='form-control toolbar-date'
                        onChange={(i) => this.setState({ filter: { ...this.state.filter, endPeriod: i.target.value } })}
                        disabled={this.state.loading || !this.state.filter.startPeriod}
                        min={this.state.filter.startPeriod}
                        max={getFDate()}
                        value={this.state.filter.endPeriod}
                    />
                </div>

                <div>
                    <label htmlFor="drivers" className='toolbar-label'>Motoristas</label>
                    {/* Select Motoristas */}
                    <Select
                        inputId='drivers'
                        isLoading={this.state.drivers.loading}
                        className='toolbar-select'
                        loadingMessage={i => `Procurando: ${i.inputValue}`}
                        placeholder="Motoristas"
                        noOptionsMessage={e => { return !e.inputValue ? 'Pesquise os motoristas!' : `"${e.inputValue}" não foi encontrado!` }}
                        options={this.state.drivers.options}
                        isMulti
                        closeMenuOnSelect={false}
                        onChange={(i) => {
                            if (!i.length) {
                                this.setState({ filter: { ...this.state.filter, idDrivers: [] } })
                            }
                            else {
                                let idDrivers = []
                                i.forEach(d => idDrivers.push(d.value))
                                this.setState({ filter: { ...this.state.filter, idDrivers } })
                            }
                        }}
                        onInputChange={(i) => {
                            if (i.length > 2) {
                                this.setState({ drivers: { ...this.state.drivers, loading: true } });
                                axios
                                    .get(`${url}/v1/telemetria/admin/cache/drivers/${encodeURI(i)}/${this.props.token}`)
                                    .then(d => {
                                        let options = [];
                                        d.data.forEach(d => options.push({ label: d.driverName, value: d.driverId }))
                                        this.setState({ drivers: { options, loading: false } });
                                    })
                                    .catch(e => console.log(e.response));
                            }
                        }}
                        isDisabled={this.state.loading}
                    />
                </div>
                <div>
                    <label htmlFor="vehicles" className='toolbar-label'>Frotas</label>
                    {/* Select Frotas */}
                    <Select
                        inputId='vehicles'
                        isLoading={this.state.licenseNumbers.loadingD}
                        loadingMessage={i => `Procurando: ${i.inputValue}`}
                        placeholder="Frotas"
                        className='toolbar-select'
                        noOptionsMessage={e => { return !e.inputValue ? 'Pesquise as frotas!' : `"${e.inputValue}" não foi encontrado!` }}
                        options={this.state.licenseNumbers.options}
                        isMulti
                        closeMenuOnSelect={false}
                        onChange={(i) => {
                            if (!i.length) {
                                this.setState({ filter: { ...this.state.filter, licenseNumbers: [] } })
                            }
                            else {
                                let licenseNumbers = []
                                i.forEach(d => licenseNumbers.push(d.label))
                                this.setState({ filter: { ...this.state.filter, licenseNumbers } })
                            }
                        }}
                        onInputChange={(i) => {
                            if (i.length > 2) {
                                this.setState({ licenseNumbers: { ...this.state.licenseNumbers, loading: true } });
                                axios
                                    .get(`${url}/v1/telemetria/admin/cache/vehicles/${encodeURI(i)}/${this.props.token}`)
                                    .then(d => {
                                        let options = [];
                                        d.data.forEach(d => options.push({ label: d.licenseNmbr, value: d.vehicleId }))
                                        this.setState({ licenseNumbers: { options, loading: false } });
                                    })
                                    .catch(e => console.log(e.response));
                            }
                        }}
                        isDisabled={this.state.loading}
                    />
                </div>
                <div>
                    <label htmlFor="groups" className='toolbar-label'>Falhas</label>

                    {/* Select Falhas */}
                    <Select
                        // isDisabled={this.state.loading}
                        // isLoading={this.state.collab.loading}
                        inputId='groups'
                        className='toolbar-select'
                        isMulti
                        loadingMessage={i => `Procurando: ${i.inputValue}`}
                        placeholder="Falhas"
                        noOptionsMessage={e => { return `"${e.inputValue}" não foi encontrado!` }}
                        options={this.state.optionsFailure}
                        closeMenuOnSelect={false}
                        onChange={(i) => {
                            if (!i.length) {
                                this.setState({ filter: { ...this.state.filter, optionsFailure: [] } })
                            }
                            else {
                                let optionsFailure = []
                                i.forEach(d => optionsFailure.push(d.value))
                                this.setState({ filter: { ...this.state.filter, optionsFailure } })
                            }
                        }}
                        isClearable
                        isDisabled={this.state.loading} />

                    <div className="toolbar-space" />
                </div>
                <input
                    type="button"
                    value='Filtrar'
                    className='telemetry-button toolbar-button toolbar-button-space'
                    onClick={() => this.getDash(this.state.filter)}
                    disabled={!this.state.filter.startPeriod || !this.state.filter.endPeriod || this.state.loading}
                />

            </ToolBar>
        )
    }


    render() {
        return (
            <div>
                {this.renderToolbar()}

                {this.state.loading ? (
                    <div className='app-tool-center-loading '>
                        <Loading />
                    </div>
                ) : (
                    <div className='card-columns custom-card-coluns'>


                        <div className='top-content-checklist'>
                            {this.state.data.listGeneralAttr.map((d, i) => {
                                return (
                                    <div key={i} style={{ width: '100%',marginRight: i % 2 === 0 ? '10px' : 0 }}>
                                        <LGCard data={d} />
                                    </div>
                                )
                            })}
                        </div>

                        <div className='content-checklist'>
                            <ListEvents maxLines={this.state.data.statusFailureAttr.maxLines} title={this.state.data.statusFailureAttr.title.label} list={this.state.data.statusFailureAttr.listAttribute} />
                        </div>
                        <div className='content-checklist'>
                            <ListEvents maxLines={this.state.data.driversAttr.maxLines} title={this.state.data.driversAttr.title.label} list={this.state.data.driversAttr.listAttribute} />
                        </div>


                        {this.state.data.listOtherQuestionsAttr.map((d, i) => {
                            if (d.listAttribute.length) {
                                return (
                                    <div key={i} className='content-checklist'>
                                        <ListEvents maxLines={d.maxLines} title={d.title.label} list={d.listAttribute} />
                                    </div>
                                )
                            } else {
                                return null
                            }
                        })}

                        {this.state.data.listFailureAttr.map((d, i) => {
                            if (d.listAttribute.length) {
                                return (
                                    <div key={i} className='content-checklist'>
                                        <ListEvents maxLines={d.maxLines} title={d.title.label} list={d.listAttribute} />
                                    </div>
                                )
                            } else {
                                return null
                            }
                        })}

                    </div>
                )}
                <div style={{ width: '440px', marginTop: '20px', alignSelf: 'center' }}>
                    <ModernAlert msg={this.state.alert.msg} color={this.state.alert.type} />
                </div>
            </div>
        )
    }

}

export default Checklist